<template>
    <div class="faq__item" @click="active  = !active" :class="{active: active}">
  
                <div class="faq__item--question flex j_sb  container pointer">
                    <h2 class="f-16 bold uppercase">{{question}}</h2>
                    <div class="faq__item--cross">
                        <span></span>
                        <span></span>
                    </div>
                </div>
                <slide-up-down :active="active" :duration="500" class="faq__item--collapsed  container">
                    <div class="faq__answer" v-html="answer"></div>   
            </slide-up-down>
    </div>
</template>

<script>
export default {
    props: ['question', 'answer', 'tags'],
    data(){
        return{
            active: false,
        }
    },
    watch: {
        active(){
          this.$store.commit('main/setState', {
              key: 'trigger_update',
              val: !this.$store.state.main.trigger_update,
          });
        }
    }
}
</script>

<style>

</style>